import { GET_DEAL_BUILDER_CUSTOMER_CONTACTS } from './getCustomerContacts';
import { GET_INVENTORY_FULL_LIST } from './getInventoryFullList';
import { GET_EQUIPMENT_DETAILS_BY_ID } from './getEquipmentDetailsById';
import { GET_DEAL_BUILDERS } from './getDealBuilders';
import { START_DEAL_BUILDER } from './startDealBuilder';
import { UPSERT_DEAL_BUILDER_CONTACTS } from './upsertDealBuilderContacts';
import { UPSERT_DEAL_BUILDER_EQUIPMENTS } from './upsertDealBuilderEquipments';

export const dealBuilderApi = {
  getCustomerContacts: GET_DEAL_BUILDER_CUSTOMER_CONTACTS,
  getInventoryFullList: GET_INVENTORY_FULL_LIST,
  getEquipmentDetailsById: GET_EQUIPMENT_DETAILS_BY_ID,
  getDealBuilders: GET_DEAL_BUILDERS,
  startDealBuilder: START_DEAL_BUILDER,
  upsertDealBuilderContacts: UPSERT_DEAL_BUILDER_CONTACTS,
  upsertDealBuilderEquipments: UPSERT_DEAL_BUILDER_EQUIPMENTS,
};

export type {
  CustomerContactItem,
  CustomerContactsQueryResponse,
  DealBuilderEntity,
  DealBuilderProposal,
  GetDealBuildersResponse,
  GetDealBuildersVariables,
  InventoryEquipmentItem,
  InventoryFullListResponse,
  ProposalContactEntity,
  ProposalEquipmentEntity,
  StartDealBuilderContactInput,
  StartDealBuilderResponse,
  StartDealBuilderVariables,
  UpsertDealBuilderContactsResponse,
  UpsertDealBuilderContactsVariables,
  UpsertDealBuilderEquipmentsResponse,
  UpsertDealBuilderEquipmentsVariables,
} from './types';
